import React, { useState, useEffect } from "react";
import get from "lodash/get";
import groupBy from "lodash/groupBy";
import mapboxgl from "mapbox-gl";
import { getLocationsList } from "config/api/locations";
import ListView from "views/ListView/ListView";
import MapView from "views/MapView/MapView";

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

const AppContainer = () => {
  /* eslint-disable no-unused-vars */
  const [isLoading, setLoading] = useState(false);
  /* eslint-enable no-unused-vars */
  const [city, setCity] = useState(null);
  const [cities, setCities] = useState([]);
  const [locations, setLocations] = useState([]);

  const fetchLocations = async () => {
    try {
      const resp = await getLocationsList();
      const status = get(resp, "status");
      if (status) {
        const citiesData = groupBy(resp.data, "acf.city");
        const citiesList = Object.keys(citiesData).sort((a, b) =>
          a === b ? 0 : a < b ? -1 : 1
        );
        setCities(citiesList);
        setLocations([...resp.data]);
      } else {
        setCities([]);
        setLocations([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchLocations();
  }, []);

  return (
    <div className="w-100">
      {!city ? (
        <div className="container">
          <ListView setCity={setCity} cities={cities} />
        </div>
      ) : (
        <MapView locations={locations} city={city} setCity={setCity} />
      )}
    </div>
  );
};

export default AppContainer;
